import { useMemo } from "react";
import { CheckInTimeEnum } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { CheckInInformationSectionComponentProps } from "./CheckInInformationSection";

export const useCheckInInformation = ({
  checkInInformation,
}: CheckInInformationSectionComponentProps) => {
  const { t } = useI18nContext();

  return useMemo(() => {
    return {
      context: {
        showCheckInTime: checkInInformation?.checkInTime != null,
        showCheckOutTime: checkInInformation?.checkOutTime != null,
      },
      text: {
        title: t("core-hotels.shop.checkInInformation.title"),
        checkInTitle: t("core-hotels.shop.checkInInformation.checkinTitle"),
        checkOutTitle: t("core-hotels.shop.checkInInformation.checkoutTitle"),
        checkInTime: checkInInformation?.checkInTime
          ? checkInInformation?.checkInTime?.CheckInTime ===
            CheckInTimeEnum.Anytime
            ? t("core-hotels.shop.checkInInformation.checkinAnytime")
            : t("core-hotels.shop.checkInInformation.checkinTime", {
                time: checkInInformation?.checkInTime?.checkInTimeFrom,
              })
          : null,
        checkOutTime: t("core-hotels.shop.checkInInformation.checkoutTime", {
          time: checkInInformation?.checkOutTime,
        }),
      },
    };
  }, [checkInInformation, t]);
};
